<div class="">
  <label class="checkbox">
    <input type="checkbox" [(ngModel)]="optionModel.value" (focus)="onFocus()" (blur)="onBlur()" (change)="onCheckedOption(optionModel)" />
    <span class="tick" id="{{optionId}}"></span>
    <span class="label no-strong">{{optionModel.name}}</span>
    @if (isImageLogo===true) {
      <img [src]="optionModel.imageLogoPath" [alt]="optionModel.name" class="icon" />
    }
  </label>
</div>